<template>
    <ViewCreance/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ViewCreance from "@/components/GesCom/Creance/ViewCreance.vue";

    export default defineComponent({
      name: "ViewCreancePage",
      components: {
        
        ViewCreance,
      },
    });
  </script>